export default function Loading () {
  return (
    <div className='w-full h-screen text-xl text-white flex justify-center items-center'>
      Loading...
    </div>
  )
}
